import { TPoint } from 'src/app/project/modules/points/points.model';
import { GET_PREFERENCES } from 'src/app/project/modules/preferences/preferences.store';
import { GET_WORKSPACES } from '../../../workspace/workspace.store';
import { TGroupedPoints } from './group-model';
import { timelineGroupBy } from './timeline-group-by';
import { transformDefaultValue } from './transform-default-value';

export function groupTimeline(_points: TPoint[]): TGroupedPoints[] {
  const preferences = GET_PREFERENCES();
  const timelineGroup = preferences.timeline?.group ? preferences.timeline.group : null;
  const property =
    timelineGroup === 'SITE' ? 'Site' : timelineGroup === 'ACCOUNT' ? 'Account' : null;

  const groupedPoints = groupTimelinePoints(_points, property);
  groupedPoints.sort((_a, _b) => timelineGroupBy(_a, _b));

  return groupedPoints;
}

function groupTimelinePoints(_points: TPoint[], property: string): TGroupedPoints[] {
  const groupedPoints: TGroupedPoints[] = [];
  const valueIndexes: {
    [key: string]: number;
  } = {};

  _points.forEach((_point, _index) => {
    let value: string = null;

    if (property === 'Site') {
      const workspaces = GET_WORKSPACES();
      const workspace = _point ? workspaces[_point.workspaceRef.id] : null;

      value = workspace?.siteName;
    } else if (property === 'Account') {
      const workspaces = GET_WORKSPACES();
      const workspace = _point ? workspaces[_point.workspaceRef.id] : null;

      value = workspace?.accountName;
    }

    value = transformDefaultValue(value);

    if (!Object.prototype.hasOwnProperty.call(valueIndexes, value)) {
      valueIndexes[value] = groupedPoints.length;
    }

    if (!groupedPoints[valueIndexes[value]]) {
      groupedPoints[valueIndexes[value]] = {
        points: [],
        value,
        id: value,
      };
    }

    groupedPoints[valueIndexes[value]].points.push(_index);
  });

  return groupedPoints;
}
